module.exports = __webpack_public_path__ + "static/media/James G. Blaine - 1884.86222c06.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/us/James G. Blaine - 1884.jpg
// module id = 501
// module chunks = 0